import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import AccountConfirmationDialog from './AccountConfirmationDialog';

function Layout({ user, onLogout }) {
  return (
    <>
      <div className="bg-field with-stars" />
      <div className="shell" data-readable="on">
        <Topbar user={user} />
        <Sidebar user={user} onLogout={onLogout} />
        <main className="main">
          <Outlet context={{ user }} />
        </main>
      </div>
      <AccountConfirmationDialog />
    </>
  );
}

export default Layout;
